import { LedStripVariantOffIcon } from './LedStripVariantOffIcon';

/**
 * author: Michael Irigoyen
 * id 6EAFDD56-E5C5-459A-B31A-0BAC693931E0
 * name led-strip-variant-off
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/led-strip-variant-off.svg
 * tags
 * - Home Automation 
 */
export const LightStripVariantOffIcon = LedStripVariantOffIcon;
export default LightStripVariantOffIcon